import { combineReducers } from "redux";
import { authentication } from "./authentication.reducer";
import { users } from "./users.reducer";
import { error } from "./error.reducer";
import { course } from "./course.reducer";
import { alert } from "./alert.reducer";
import { mainlogin } from "./mainlogin.reducer";
import { cart } from "./cart.reducer";
import { userConstants } from "../_constants";
import { bundleCourses } from "./bundle.reducer";

const appReducer = combineReducers({
  authentication,
  users,
  course,
  error,
  alert,
  mainlogin,
  cart,
  bundleCourses,
});

const rootReducer = (state, action) => {
  if (action.type === userConstants.LOGOUT) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
